import { assert } from '../app/logger.js';
import { navigation } from '../app/navigation.js';
import { PanelBase } from '../ui/panel_base.js';

/**
 * Pic upload panel, used on small screen devices.
 */
class PicUploadPanel extends PanelBase {
  static id = navigation.kPicUploadPanelId;

  async switchOn(params) {
    this.params = params;
    this.marker = this.#markers.get(this.params.markerid);
    this.#picUploadControl.searchBounds = await this.#map.retrieveBounds();
    if (!this.params.doNotSetPic) {
      assert(
        this.marker,
        `[picupload] no marker for ${this.params.markerid} id`
      );
      this.#picUploadControl.setPic(this.marker.anchorPicIndex);
    }
    super.switchOn();

    // Refresh the image slider navbar after the panel is shown.
    this.#picUploadControl.focus();
    await this.#picUploadControl.refreshNavBar();
  }

  get historyState() {
    return [
      {
        page: this.page,
        params: { markerid: this.marker.id },
      },
      `Upload pictures | CamperAid`,
      '',
    ];
  }

  attach({ map, markers, picUploadControl }) {
    this.#map = map;
    this.#markers = markers;
    this.#picUploadControl = picUploadControl;
    this.append(picUploadControl);
  }

  initialize() {
    super.initialize();
    this.classList.add('fixed');
  }

  #markers;
  #map;
  #picUploadControl;
}

navigation.registerPanel(PicUploadPanel);

export { PicUploadPanel };
